module.exports = __webpack_public_path__ + "img/img17.b72df209.png";